module.exports = __webpack_public_path__ + "static/media/Torch01.ab611477.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/GameTheme/Background/Torch01.png
// module id = 700
// module chunks = 0